import React, { useEffect, useRef, useState } from 'react'
//import { DebounceInput } from 'react-debounce-input'
import { useTranslation } from 'react-i18next'

function FilterSearch({
	value = '',
	onSearchChange = null,
	filterData = null,
	setFilterData = null,
	searchKey = 'search',
	pageKey = 'page',
	minLength = 2,
	debounceMs = 1000,
}) {
	const { t } = useTranslation()
	const initialValue = value || filterData?.[searchKey] || ''
	const [draftValue, setDraftValue] = useState(initialValue)
	const firstDebounceRunRef = useRef(true)
	const debounceTimerRef = useRef(null)

	useEffect(() => {
		const nextValue = value || filterData?.[searchKey] || ''
		setDraftValue(nextValue)
	}, [value, filterData, searchKey])

	function requestToServer(searchValue) {
		if (searchValue.length !== 0 && searchValue.length < minLength) return

		if (typeof onSearchChange === 'function') {
			onSearchChange(searchValue)
			return
		}

		if (typeof setFilterData === 'function') {
			setFilterData(prev => ({
				...(prev || filterData || {}),
				[searchKey]: searchValue,
				[pageKey]: null,
			}))
		}
	}

	function handleChange(value) {
		setDraftValue(value)
	}

	function handleSubmitNow() {
		if (debounceTimerRef.current) {
			clearTimeout(debounceTimerRef.current)
			debounceTimerRef.current = null
		}
		requestToServer(draftValue)
	}

	useEffect(() => {
		// Skip first render to prevent extra request on mount.
		if (firstDebounceRunRef.current) {
			firstDebounceRunRef.current = false
			return
		}

		debounceTimerRef.current = setTimeout(() => {
			requestToServer(draftValue)
		}, debounceMs)

		return () => {
			if (debounceTimerRef.current) {
				clearTimeout(debounceTimerRef.current)
				debounceTimerRef.current = null
			}
		}
	}, [draftValue, debounceMs]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className="position-relative">
			<i className="uil-search input-search-icon"></i>
			<input type="text" className="form-control"
				placeholder={t('search') + '...'}
				value={draftValue}
				onChange={(e) => handleChange(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						handleSubmitNow()
					}
				}}
			/>
			{/* <DebounceInput
				value={filterData.search}
				type="text"
				className="form-control"
				placeholder={t('search') + '...'}
				minLength={3}
				debounceTimeout={1000}
				// onChange={(e) => requestToServer(e.target.value)}
				onKeyUp={(e) => {
					if (e.keyCode === 13) {
						requestToServer(e.target.value)
					}
				}}
			/> */}
		</div>
	)
}

export default FilterSearch
